// THE SHOP'S LETTERMARK, for a shop with no logo on file (TW-0048). Moved out of Form.tsx unchanged on 2026-09-26
// (TW-0206), because the QR code's choice draws the same mark on top of its two buttons and a second copy of the rule
// would be a second rule.

/** A "word" of punctuation alone is a joiner, never an initial (2026-10-18): "Ink & Iron Parlor" drew "&I" because "&" stripped
 *  to nothing, which no skip word matches. ASCII punctuation and the middle dot, the dashes and the bullet a name is written
 *  with; a word of digits ("618 Ink") or of letters outside ASCII ("Éclat") is still a word. */
const JOINER = /^[\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7E\u00B7\u2013\u2014\u2022]+$/;

/** "Fountain Square Tattoo" → "FS", "Obsidian Ink" → "O", "The Black Lotus" → "BL", "Ink & Iron Parlor" → "IP": up to 2
 *  initials, skipping articles, the trade words every shop name carries and a joiner ("&", "+"); a name that is all trade
 *  words ("Tattoo Studio") falls back to its own first letters. */
export function initials(name: string): string {
  const skip = new Set(['the', 'a', 'an', 'and', 'of', 'tattoo', 'tattoos', 'studio', 'shop', 'ink', 'co', 'llc', 'inc']);
  const words = (name || '').split(/\s+/).filter((w) => w && !JOINER.test(w));
  const kept = words.filter((w) => !skip.has(w.toLowerCase().replace(/[^a-z]/g, '')));
  const src = kept.length ? kept : words;
  return src.slice(0, 2).map((w) => w[0].toUpperCase()).join('') || '?';
}
